import React, { Component } from 'react'
import AdjustmentTransactionsModalUI from './AdjustmentTransactionsModalUI'

class AdjustmentTransactionsModalSF extends Component {
  render() {
    return (
      <AdjustmentTransactionsModalUI
        context={this.props.context}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
        title={this.props.title}
        transactionList={this.props.transactionList}
        totalAmount={this.props.totalAmount}
        viewPageUrl={this.props.viewPageUrl}
      />
    )
  }
}

export default AdjustmentTransactionsModalSF

